import { render, staticRenderFns } from "./ProductSalesPageIncludedEvents.vue?vue&type=template&id=1f1dae90&scoped=true&"
import script from "./ProductSalesPageIncludedEvents.vue?vue&type=script&lang=ts&"
export * from "./ProductSalesPageIncludedEvents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1dae90",
  null
  
)

export default component.exports